
import React, { useEffect, useState } from 'react';
import { getBrandsFromFirestore } from '../../firebase/brandService';
import { getGenresFromFirestore } from '../../firebase/genreService';
import { getColorsFromFirestore } from '../../firebase/colorService';
import { useParams, useNavigate } from 'react-router-dom';
import { getToolsFromFirestore, deleteToolFromFirestore } from '../../firebase/toolService';
import { useAuth } from '../../firebase/AuthContext';
import styles from './ToolDetail.module.css';


const ToolDetail = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [tool, setTool] = useState(null);
  const [brandList, setBrandList] = useState([]);
  const [genreList, setGenreList] = useState([]);
  const [colorList, setColorList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    (async () => {
      const [tools, brands, genres, colors] = await Promise.all([
        getToolsFromFirestore(user.uid),
        getBrandsFromFirestore(user.uid),
        getGenresFromFirestore(user.uid),
        getColorsFromFirestore(user.uid)
      ]);
      setBrandList(brands);
      setGenreList(genres);
      setColorList(colors);
      const found = tools.find(t => t.id === id);
      setTool(found || null);
    })();
  }, [user, id]);


  const handleDelete = async () => {
    if (!window.confirm('本当に削除しますか？')) return;
    await deleteToolFromFirestore(tool.id);
    navigate('/tools/list');
  };

  if (!tool) return <div className={styles.container}>道具が見つかりません</div>;

  return (
    <div className={styles.container}>
      <button className={styles.button} style={{ marginBottom: 16 }} onClick={() => navigate('/tools/list')}>一覧に戻る</button>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>{tool.name}</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            className={styles.button}
            style={{ background: '#1976d2', padding: '4px 14px', fontSize: '0.95em' }}
            onClick={() => navigate(`/tools/edit/${tool.id}`)}
          >
            編集
          </button>
          <button
            className={styles.button}
            style={{ background: '#e53935', padding: '4px 14px', fontSize: '0.95em' }}
            onClick={handleDelete}
          >
            削除
          </button>
        </div>
      </div>
      {tool.images && tool.images.length > 0 && (
        <div className={styles.imagePreviewArea}>
          {tool.images.map((img, i) => (
            <img key={i} src={img} alt={`道具画像${i+1}`} className={styles.imagePreview} />
          ))}
        </div>
      )}
  {tool.genre && <div className={styles.info}>ジャンル: {genreList.find(g => g.id === tool.genre)?.name || tool.genre}</div>}
  {tool.brand && <div className={styles.info}>ブランド: {brandList.find(b => b.id === tool.brand)?.name || tool.brand}</div>}
  {tool.color && <div className={styles.info}>色: {colorList.find(c => c.id === tool.color)?.name || tool.color}</div>}
      {tool.description && <div className={styles.info}>詳細: {tool.description}</div>}
    </div>
  );
};

export default ToolDetail;
